import React from "react";
import TableWidget from "../../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getDeviceHistory } from "../../../../redux/api/admin.api";

import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import {
  devicesNomenclatureTableHeader,
  getDevicesNomenclatureTableData,
} from "./tableConfigs/devicesNomenclatureTableConfig";
import DevicesNomenclatureActionButtons from "./tableConfigs/DevicesNomenclatureHistoryActionButtons";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";

function DevicesNomenclatureHistory() {
  const dispatch = useAppDispatch();

  const { routeParams } = useRoutesHelper();
  const { sn } = routeParams || {};

  const {
    admin: {
      deviceHistory: {
        data: { data: devicesData, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        getDeviceHistory({
          page: action.tablePagination.page,
          per_page: action.tablePagination.rowsPerPage,
          sn: sn,
          ...action.tableSearch,
        }),
      );
    }
  };

  return (
    <TableWidget
      tableTitle="Istoric dispozitiv"
      tableHeaderData={devicesNomenclatureTableHeader}
      tableItemsData={getDevicesNomenclatureTableData(devicesData)}
      handleTableActions={handleTableActions}
      ActionButtonsComponent={DevicesNomenclatureActionButtons}
      tableLoading={isLoading}
      totalItems={total}
      borderedRow
    />
  );
}

export default DevicesNomenclatureHistory;
